import { leftOutNote } from "../lib/overs";

/** D260: the ground's economy leaves out spells with unreadable overs; say how many. */
export default function GroundOversLeftOut({ n }) {
  const note = leftOutNote(n);
  if (!note) return null;
  return (
    <p className="mt-2 text-xs text-slate-600" data-testid="ground-overs-left-out">
      Economy: {note}.
    </p>
  );
}
